import { Fragment, useCallback } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import { Coupon as CouponBase } from 'lmcv/components/Coupon'
import { Icon } from 'lmcv/components/Icon'
import { formatter } from 'lmcv/containers/Coupon/helpers'
import { useModuleModal } from 'lmcv/hooks/modal'

function Coupon ({
  id,
  type,
  thumbnail,
  shortDescription,
  remainingDays,
  isActive,
  ...props
}) {
  const {
    get: { user }
  } = useSelector(state => state.module, shallowEqual)
  const modal = useModuleModal({
    componentProps: {
      id: id,
      category: type,
      active: isActive
    }
  })

  const remainingEl = (
    <Fragment>
      <Icon name="clock" />
      {formatter.days(remainingDays)}
    </Fragment>
  )

  const hasAccess = user.isAuthenticated && user.isMember

  const couponProps = {
    id,
    type,
    image: thumbnail,
    description: shortDescription,
    category: 'percentage',
    footerText: {
      default: remainingEl,
      active: remainingEl
    },
    isDisabled: !hasAccess,
    isActive,
    onClickCoupon: useCallback(() => {
      if (hasAccess) {
        modal()
      }
    }, [modal, hasAccess]),
    ...props
  }

  return <CouponBase {...couponProps} />
}

export default Coupon
